import { Component } from '@angular/core';
import { MenuController, Platform } from '@ionic/angular';
import { CacheService } from 'ionic-cache';
import { Router } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { AuthenticationService } from './services/authentication.service';
import { CentralAuthenticationService } from './services/central-authentication.service';
import { UserService } from './services/user.service';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  public appPages = [
    { title: 'Home', url: '/home', icon: 'home' },
    { title: 'Expenses', url: '/expenses', icon: 'wallet' },
    { title: 'Time Sheet', url: '/timesheet', icon: 'stopwatch'},
    { title: 'People', url: '/people', icon: 'people'},
    { title: 'Invoices', url: '/invoice', icon: 'receipt'},
  ];

  public adminMenu;
  public dynamicMenu;
  public username;
  public nameSeparator = ', ';
  public menuType;
  public isLoggedIn = false;

  constructor(platform: Platform,
              private cache: CacheService,
              private themeService: ThemeService,
              private router: Router,
              private menu: MenuController,
              private userService: UserService,
              private authenticationService: AuthenticationService,
              private centralAuthService: CentralAuthenticationService) {
    this.userService.loadCurrentUser('all');
    this.dynamicMenu = this.authenticationService.$dynamicMenu;
    this.themeService.$screenWidth.subscribe(value => {
      if (value < this.themeService.breakpointSm)
       {this.menuType = 'overlay';}
      else
       {this.menuType = 'push';}
    });

    this.userService.$currentUser.subscribe(
      user => {
        if (user.length > 0) {
          user = user[0];
          if (user.profile.name.length > 0) {
            this.username = this.nameSeparator + user.profile.name;
          }
          else if (user.email.length > 0) {
            const name = user.email.match(/^([a-zA-Z]+)/)[0];
            this.username = this.nameSeparator + name.charAt(0).toUpperCase() + name.slice(1);
          }
        }
      }
    );

    this.centralAuthService.$current.subscribe(cur => {
      const loggedIn = !!cur;

      this.isLoggedIn = loggedIn;

      if (loggedIn) {
        document.body.classList.add('logged-in');
        this.menu.enable(true);
      } else {
        document.body.classList.remove('logged-in');
        this.menu.enable(false);
        this.menu.close();
      }
    });

  }

  LogoutCentral() {
    this.cache.clearAll();
    localStorage.clear();
    sessionStorage.clear();
    indexedDB.databases().then((dbs) => {
      dbs.forEach((db) => indexedDB.deleteDatabase(db.name));
    });
    this.logoutTenant();
  }

  async navigateAndClose(url) {
    await this.router.navigateByUrl(url);
    await this.menu.toggle();
  }

  logoutTenant() {
    this.authenticationService.logout();
    this.centralAuthService.logout();
  }

  consoleLog(x) {console.log(x);}

  async onMainContentClick(ev: MouseEvent) {
    const openMenu = await this.menu.getOpen();
    if (!openMenu) return;

    const path = ev.composedPath() as HTMLElement[];
    const clickedInsideMenu = path.some((el: any) => {
      try {
        return el?.tagName?.toLowerCase() === 'ion-menu' || el?.closest?.('ion-menu');
      } catch { return false; }
    });
    if (clickedInsideMenu) return;

    await this.menu.close();
  }

}
